import { FormControl } from "@angular/forms";

export class Constants {
  public static DATA_SEP: string = "↕";
  public static VALID_INSTANCE_URL_FORMAT_REGEX: string = "/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/";
  public static ACCESSIBLEBY_MYFILES_STORAGE: string = "accessibleby_Myfiles";
  public static DOWNLOADRIGHTS_MYFILES_STORAGE: string = "downloadrights_Myfiles";
  public static ACCESSIBLEBY_OTHERFILES_STORAGE: string = "accessibleby_Otherfiles";
  public static DOWNLOADRIGHTS_OTHERFILES_STORAGE: string = "downloadrights_Otherfiles";
  public static LINKEXPIRES_STORAGE: string = "linkexpires";
  public static WATERMARK_MYFILES_STORAGE: string = "watermark_Myfiles";
  public static APPROVE_NEW_VERSIONS_MYFILES_STORAGE: string = "approvenewversions_Myfiles";
  public static WATERMARK_OTHERFILES_STORAGE: string = "watermark_Otherfiles";
  public static APPROVE_NEW_VERSIONS_OTHERFILES_STORAGE: string = "approvenewversions_Otherfiles";
  public static NOTIFY_EDIT_DOWNLOAD_PRINT_STORAGE: string = "notify_edit_download_print";
  public static SHOW_DIALOG_STORAGE: string = "show_dialog_sharing";
  public static API_CALL_SHARE_SETTINGS_TIME_STORAGE: string = "apicallsharesettingstime";
  public static API_CALL_CHUNK_UPLOAD_CONFIGURATION: string = "apicallchunkuploadconfig";
  public static CHUNK_UPLOAD_ENABLE: string = "CHUNK_UPLOAD_ENABLE";
  public static CHUNK_CONFIG_TEXT_CHUNK_SIZE: string = "CHUNK_SIZE";
  public static CHUNK_CONFIG_TEXT_CHUNK_FILE_SIZE: string = "CHUNK_FILE_SIZE";
  public static CHUNK_UPLOAD_ENABLE_FLAG: string = "CHUNK_UPLOAD_ENABLE_FLAG";
  public static COLLABORATE_VERSION: string = "coll_version";



  public static VERSION_5_7: string = "5.7.0";

  public static VIRUS_DETECTED = 33
  public static BLACK_OR_WHITE_LISTED = 41
  public static QUOTA_EXCEEDED = 45
  public static FILE_SHARING_DISABLED = 52
  public static EXTERNAL_USER_SHARE_ACCESS_DENIED_WHEN_SHARING_ON = 55
  public static ENABLE_API_IS_FALSE = 51
  public static API_ALLOWED_IP_RESTRICTION = 53
  public static SQL_CONNECTION_LIMIT_EXCEEDED = 54
  public static SHARE_LINK_RESTRICTED = 172
  public static CONNECTION_LIMIT_EXCEED = 429
  public static IP_RES = 431
  public static NO_INTERNET = 0
  public static CHUNK_SIZE_MIN_MB = 190;
  public static CHUNK_SIZE_IN_BYTES = 1024 * 1024 * this.CHUNK_SIZE_MIN_MB; //190MB;
  public static CHUNK_MISSING_FILE_DETAILS = 557;
  public static CHUNK_NOT_ALLOWED = 558;
  public static CHUNK_SIZE_MISMATCH = 559;
  public static CHUNK_RENAME_ERROR = 560;

  static WS_FAVOURITE = 1;
  static WS_SITE = 2;
  static WS_FOLDERS = 3;
  static API_DATA: string = "api_data";
  static IS429: string = "is429";
  static TIMEOUT429: string = "timeout429";
  static APPBASE_URL_403 = "apiapplication?appidentifier";
  static LOGGED_OUT = 1;
  public static EXPIRY_DATE_TEXT: string = "31 Dec 9999 00:00";  //Expiry date format used in share link functionality
  static PASSWORD_PROTECTED = "Password protection";
  static TWO_FACTOR_AUTH = "Two-factor authentication";
  static TERMS_AND_CONDITIONS = "Terms and conditions";

  static REFRESH: string = "Refresh";
  static ALERT: string = "Alert";
  static PRODUCT_NAME = "HighQ"
  static MY_SITE = "My site"
  // public static UN_AUTHORIZE = "You do not have permissions to access the requested resource."
  //  public static UPLOAD_ERROR = "You do not have permission to upload a file."
  public static VIRUS_DETECTED_MSG = "A virus was detected. Your upload has been terminated."
  public static BLACK_OR_WHITE_LISTED_MSG = "This file type is not allowed. Your upload has been terminated."
  public static QUOTA_EXCEEDED_MSG = "You have exceeded your storage quota. Please contact a System Administrator for support."
  public static FILE_SHARING_DISABLED_MSG = `File sharing is disabled on ${Constants.PRODUCT_NAME}. Please contact a System Administrator for support.`
  public static EXTERNAL_USER_SHARE_ACCESS_DENIED_WHEN_SHARING_ON_MSG = `File sharing on ${Constants.PRODUCT_NAME} is disabled for external users. Please contact a System Administrator for support.`
  public static ENABLE_API_IS_FALSE_MSG = `API calls for your IP address are disabled on ${Constants.PRODUCT_NAME}. Please contact a System Administrator for support.`
  public static API_ALLOWED_IP_RESTRICTION_MSG = `Your IP address is not allowed to make API calls on ${Constants.PRODUCT_NAME}, please contact a System Administrator.`
  public static SHARE_LINK_RESTRICTED_MSG = "Sharing via a link is restricted."//Share link settings are inherited from "instance name"
  public static ERROR_CHUNK_NOT_ALLOWED = "Chunk not allowed.";
  public static COMMON_ERR_MSG = "Unable to connect to the remote server. Please try again later."
  public static CONNECTION_LIMIT_EXCEED_MSG = "The server request limit was exceeded. Please try again in a few minutes or contact a System Administrator if the problem persists."
  public static NO_INTERNET_MSG = "No internet connection is detected. Please check your device."
  public static ERROR_MSG_404 = "Unable to connect. This could be because: The remote server is temporarily unavailable.<br>\u25CF A previously redirected remote server is no longer available.<br>If the issue persists, contact your administrator.";
  static APPBASE_URL_MSG = "Please enter a valid URL or check the address and try again.";
  static ERROR_MSG_403 = "You do not have the correct permissions to perform this action.";
  static LOGGED_OUT_MSG = "You are logged out";
  static REFRESH_SITE_RES_MSG = "Once authenticated, please close the browser window and tap refresh to continue.";
  static IP_RES_ERR_MSG = "This site can only be accessed within the specified IP range"
  static FILE_LENGTH_GREATER: string = "Maximum allowed file size is 200 MB";
  static FILE_LENGTH_ZERO: string = "Zero KB files are not supported"
  static UPLOAD_COMMAN_ERROR: string = "Unable to upload to server";
  static UPLOAD_ANOTHER = "Browse for other file"
  static DRAG_AND_DROP = "Drag and drop your file here"
  static OR = "or"
  static BROWSE_FOR_FILE = "Browse files from your device"
  static UPLOAD_FILE_LOCATION = "Upload file to:"
  static SHARE_LINK = "Share link";
  static NEXT = "Next";
  static CANCEL = "Cancel";
  static CONTINUE = "Continue";
  static ERROR = "Error";
  static OK = "Ok";
  static CONTINUE_CANCEL_DESC = "Click <b>Continue</b> to begin authentication for access to this site or <b>Cancel</b> to go back.";
  static SITENAME_DESC = " site has the following restrictions applied:"
  static RESTRICTED_SITES = "Restricted site"

  public static UNSUPPORTED_VIEW_FILE = "The online viewer is unable to preview this file type. Allow recipients to download the file instead?"
  public static UNSUPPORTED_VIEW_FOLDER = "The online viewer is unable to preview folders. Allow recipients to download the folder instead?"
  public static UNSUPPORTED_FILE_FOLDER = 3;
  public static UNSUPPORTED_VIEW_TITLE = "Unsupported download rights";
  public static LOGOUT_TITLE = "Logout";
  public static SURE_LOGOUT = "Are you sure want to logout?";
  public static SURE_LOGOUT_CODE = 4;

  //public static ENTER_PASSWORDS = "Please enter a password"
  //public static MIN_PASSWORD_VALIDATION = "Password must be 8 characters or more"
  public static MAX_PASSWORD_VALIDATION = "Password must be 25 characters or less"
  public static PASSWORD_VALIDATION = "Password must contain: At least 8 characters. 1 uppercase character. 1 lowercase character. 1 number and 1 special character."


  static NO_FAVOURITES = "There are no favourite results to show"
  static NO_FAVOURITES_SITES = "There are no favourite sites to show"
  static NO_FAVOURITES_FILES = "There are no favourite files to show"
  static NO_FAVOURITES_FOLDERS = "There are no favourite folders to show"

  static NO_FILE_FOLDERS = "There are no files or folders to show"
  static NO_FOLDERS = "There are no folders to show"
  static NO_FILES = "There are no files to show"

  static NO_SITES = "There are no sites to show"

  static NO_RECENT = "There are no recent results to show"
  static UPLOAD_FILE_TO_HQ = "Upload file to HighQ"
  static DONE = "Done"
  static UPLOAD_DESC_TEXT = "Please choose a location to upload your file.";
  static SHARE_LINK_DESC = "Optionally, share a link for this file within your current chat session ";
  static GENERATING_LINK = "Generating link";
  static LOADING = "Loading...";
  static LOAD_MORE_RESULTS = "Load more results";
  static SMART_FOLDER_SHARE_LINK = "You can't share a Smart folder";

  /*Login*/
  static LoginPart1Heading: string = "Content sharing";
  static LoginPart1Information: string = "Securely share links to content within your HighQ instance with the option to apply your own restrictions.";
  static LoginPart2Heading: string = "File uploading";
  static LoginPart2Information: string = "Simple drag-and-drop uploading of files on your system directly into your HighQ instance.";
  static LoginInfoTap: string = "Tap";
  static LoginInfoTapEnd: string = "to complete the connection process in your browser.";
  static LoginGetStartedButtonText: string = "Get started";
  static LoginKBNoteText: string = "For help and support, visit the ";
  static LoginKBNoteLinkText: string = "Knowledge base";
  static KNOWLEDGEBASELINK: string = "https://knowledge.highq.com/help/apps-plugins-and-connectors/tr-highq-app-for-microsoft-teams"
  static HIGHQDEMOTEXT: string = "To find out how the HighQ platform can help your business boost productivity, seamlessly collaborate with others, share valuable insights, plus engage with clients and colleagues, ";
  static HIGHQDEMOLINKTEXT: string = "visit this page"
  static HIGHQDEMOTEXTEND: string = " for further details and to book a demo";
  static HIGHQDEMOLINK: string = "https://legal.thomsonreuters.com/en/products/highq"

  /*Instance*/
  static InstanceTitle: string = "Welcome to Thomson Reuters HighQ for Microsoft Teams";
  static InstanceInfo: string = "Share and interact with content from HighQ to simplify your Microsoft Teams workflows.";
  static InstanceLabel: string = "Enter your instance URL";
  static InstanceErrorMessage: string = "Invalid instance url. Please enter valid url";
  static InstanceBannerMessage: string = "After authentication is complete, switch back to Microsoft Teams to find this app under the More Actions menu (three dots), located under the message composition field.  ";
  static InstanceLoadingButtonText: string = "Loading...";
  static InstanceConnectButtonText: string = "Connect";
  static InstanceInputPlaceholder: string = "e.g. collaborate.yourdomain.com";

  /*oAuth*/
  static oAuthAuthenticatingHeading: string = "Authorisation...";
  static oAuthAuthenticatingInformation: string = "Authorisation with HighQ Thomson Reuters Microsoft Teams application is in-progress.";
  static oAuthAuthenticatedHeading: string = "Authorisation Succeeded";
  static oAuthAuthenticatedInformation: string = "Authorisation with HighQ Thomson Reuters Microsoft Teams application has been completed successfully! Switch to Microsoft Teams to find this app located under the message composition area.";
  static oAuthCloseButton: string = "Close";

  /*Access Denided */
  static AccessDeniedHeading: string = "Access Denied";
  static AccessDeniedInformation: string = "This application only works within Microsoft Teams";


  static MAXPASSWORDCHAR = 25;
  static PASSWORD_STRENGTH = "Password strength :"

  public static ERRORMSG;

  public static passwordValidator(control: FormControl) {
    var strPwrdVal = control.value;
    var strErrorMsg = "";

    if (strPwrdVal != undefined) {
      var intUpperValid = (strPwrdVal.match(/[A-Z]/g) || []).length;
      var intLowerValid = (strPwrdVal.match(/[a-z]/g) || []).length;
      var intNumberValid = (strPwrdVal.match(/[0-9]/g) || []).length;
      var isSpecialCharValid = (strPwrdVal.length > (intUpperValid + intLowerValid + intNumberValid));
      var intCount = 0;
      var strMsg = [];
      if (strPwrdVal.length < 8) {
        strMsg[intCount] = "8 characters";
        intCount++;
      }
      if (intUpperValid < 1) {
        strMsg[intCount] = "1 uppercase character";
        intCount++;
      }
      if (intLowerValid < 1) {
        strMsg[intCount] = "1 lowercase character";
        intCount++;
      }
      if (intNumberValid < 1) {
        strMsg[intCount] = "1 number";
        intCount++;
      }
      if (!isSpecialCharValid) {
        strMsg[intCount] = "1 special character";
      }
      if (strMsg.length > 0) {
        strErrorMsg = "Password must contain: At least ";
        var intLen = strMsg.length;
        for (let j = 0; j < intLen; j++) {
          if (j > 0 && j == intLen - 1)
            strErrorMsg += " and ";
          else if (j > 0)
            strErrorMsg += ", ";
          strErrorMsg += strMsg[j];
        }
        strErrorMsg += ".";
      }
    } else{
      strErrorMsg = Constants.PASSWORD_VALIDATION
     }
      
    if ((strErrorMsg.trim()).length > 0) {
      Constants.ERRORMSG = strErrorMsg
      return { strErrorMsg: true }
    }
    else {
      return null
    }
  }
}
